import Link from "next/link";
import { getImageURL } from "../../utils/getImageURL";
import { priceFormatter } from "../../utils/priceFormatter";
import { AdoptionTaxCreditProps } from "./adoptionTaxCredit";

export function DonatedFund(props: AdoptionTaxCreditProps) {
  const buttonClass =
    "inline-block rollover-animation text-body-3-medium rounded-[80px] border-2 border-teal bg-white py-[12px] px-[40px] text-black";

  return (
    <div className="rounded-[15px] bg-backgroundgray px-[20px] py-[40px] md:px-[50px] md:py-[50px]">
      <div>
        {props.moduleInfo.donation?.percentImage && (
          <img
            src={getImageURL(props.moduleInfo.donation.percentImage).url()}
          />
        )}
      </div>
      <h2 className="text-head-6 mt-8">{props.moduleInfo.donation?.heading}</h2>
      <p className="text-body-3 mt-6">
        {props.moduleInfo.donation?.description}
      </p>
      <p className="text-deco-head-6 mt-4 text-onyx">
        {props.moduleInfo.donation?.donatedHeading}
      </p>
      {props.moduleInfo.donation?.donatedValue && (
        <h3 className="text-head-1 text-gradient-default mt-2">
          <em>{priceFormatter(props.moduleInfo.donation.donatedValue)}</em>
        </h3>
      )}
      {props.moduleInfo.donation?.ctaURL && (
        <div className="mt-8">
          <Link className={buttonClass} href={props.moduleInfo.donation.ctaURL}>
            {props.moduleInfo.donation.ctaText}
          </Link>
        </div>
      )}
    </div>
  );
}
